import React from "react";
import { withStyles } from "@material-ui/styles";
import CompanyRegionality from "../../Components/CompanyRegionality";

import { Card, Grid, Typography } from "@material-ui/core";

import {
  SignalWifi0Bar,
  SignalWifi1Bar,
  SignalWifi2Bar,
  SignalWifi3Bar,
  SignalWifi4Bar,
} from "@material-ui/icons";

import { Skeleton as Skelly } from '@material-ui/lab';

const Skeleton = (props) => 
  <Skelly animation="wave" {...props} />

const dateFormat = require("dateformat");

const styles = (theme) => ({
  root: {
    margin: "30px 30px",
  },
  paper: {
    padding: theme.spacing(4),
    margin: "20px",
  },
  contentContainer: {
    padding: theme.spacing(4),
  },
  paragraph: {
    textAlign: "left",
  },
  spacer: {
    padding: theme.spacing(2),
    width: "100%",
  },
  "@media (max-width: 767px)": {
    root: {
      textAlign: "left",
      margin: "30px 8px"
    }
  }
});

const formatStr = "mmmm dS, yyyy";

class RemoteStatus extends React.Component {
  constructor(props) {
    super(props);
  }

  generateText = (
    remoteSince,
    remoteUntil,
    perm,
    remotePolicy,
    companyName,
    alwaysBeenRemote,
    policyDuration
  ) => {

    if (this.props.loading) {
      return (
        "companyName" +
        " has always embraced remote work and continues to do so through the Coronavirus pandemic."
      );      
    }

    if (alwaysBeenRemote) {
      return (
        companyName +
        " has always embraced remote work and continues to do so through the Coronavirus pandemic."
      );
    }
    if (remotePolicy === "temp-remote") {
      const returnDateStr = policyDuration ? ". Their return date is indefinite." : `. They have provided a tentative return date of ${dateFormat(remoteUntil, formatStr)}.`;
      return (
        companyName +
        " has decided to temporarily shift many of their operations off-site. They initially announced this policy on " +
        dateFormat(remoteSince, formatStr) +
        returnDateStr
      );
    }
    if (remotePolicy === "remote-friendly") {
      return (
        companyName +
        " is now embracing remote workers by implementing a remote friendly policy. They announced this change on " +
        dateFormat(remoteSince, formatStr)
      );
    }
    if (remotePolicy === "remote-first") {
      return (
        companyName +
        " is now primarily targeting employees who are able to fulfill their duties remotely. They announced this change on " +
        dateFormat(remoteSince, formatStr)
      );
    }
    if (remotePolicy === "fully-distributed") {
      return (
        companyName +
        " has now become fully distributed. They announced this change on " +
        dateFormat(remoteSince, formatStr)
      );
    }
  };

  generatePolicy = (remotePolicy) => {

    if (this.props.loading) {
      return null;  
    }

    if (remotePolicy === "temp-remote") {
      return (
        <Grid container alignItems="center" justify="center">
          <SignalWifi1Bar />
          <Typography
            display="inline"
            variant="body1"
            style={{ color: "grey" }}
          >
            Temporarily Remote
          </Typography>
        </Grid>
      );
    }
    if (remotePolicy === "remote-friendly") {
      return (
        <Grid container alignItems="center" justify="center">
          <SignalWifi2Bar />
          <Typography
            display="inline"
            variant="body1"
            style={{ color: "grey" }}
          >
            Remote Friendly
          </Typography>
        </Grid>
      );
    }
    if (remotePolicy === "remote-first") {
      return (
        <Grid container alignItems="center" justify="center">
          <SignalWifi3Bar />
          <Typography
            display="inline"
            variant="body1"
            style={{ color: "grey" }}
          >
            Remote First
          </Typography>
        </Grid>
      );
    }
    if (remotePolicy === "fully-distributed") {
      return (
        <Grid container alignItems="center" justify="center">
          <SignalWifi4Bar />
          <div style={{ display: "inline", width: 8, height: 1 }} />
          <Typography
            display="inline"
            variant="body1"
            style={{ color: "grey" }}
          >
            Fully Distributed
          </Typography>
        </Grid>
      );
    }
  };

  renderLabel = (label, value, xs) => {
    const { loading } = this.props;

    if (loading) {
      return (
        <Grid item xs={xs || 6} sm={3}>
          <Skeleton>
            <Typography variant="body1" style={{ color: "grey", fontWeight: 300 }} align="left">
              {label}
            </Typography>
          </Skeleton>
          <Skeleton>
            <Typography variant="body1" style={{ fontWeight: 400 }} align="left">
              {value}
            </Typography>
          </Skeleton>
        </Grid>        
      )
    }
    return (
      <Grid item xs={xs || 6} sm={3}>
        <Typography variant="body1" style={{ color: "grey", fontWeight: 300 }} align="left">
          {label}
        </Typography>
        <Typography variant="body1" style={{ fontWeight: 400 }} align="left">
          {value}
        </Typography>
      </Grid>
    );
  };

  render() {
    const {
      classes,
      remoteSince,
      remoteUntil,
      perm,
      remotePolicy,
      companyName,
      alwaysBeenRemote,
      policyDuration,
      loading
    } = this.props;

    let str;

    if (!remoteSince) {
      str = "Not Available";
    } else {
      str =
        dateFormat(remoteSince, formatStr) == "August 5th, 1991"
          ? "Always"
          : dateFormat(remoteSince, formatStr);
    }

    return (
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {
              loading ? (
                <Skeleton variant="text">
                  <Typography variant="h5" gutterBottom align="left">
                    Remote Work Policy
                  </Typography>
                </Skeleton>
              ) : (
                <Typography variant="h5" gutterBottom style={{ fontFamily: "Arvo" }} align="left">
                  Remote Work Policy
                </Typography>
              )
            }
            {
              loading ? (
                <>
                  <Skeleton>
                    <Typography variant="body1" style={{ fontFamily: "Lato"}} align="left">
                      "has always embraced remote work and continues to do so through the Coronavirus pandemic."
                    </Typography>
                  </Skeleton>
                  <Skeleton>
                    <Typography variant="body1" style={{ fontFamily: "Lato"}} align="left">
                      "has always embraced remote work and continues to do so through the Coronavirus pandemic."
                    </Typography>                  
                  </Skeleton>
                </>

              ) : (
                <Typography variant="body1" style={{ fontFamily: "Lato", textAlign: "left" }}>
                  {this.generateText(
                    remoteSince,
                    remoteUntil,
                    perm,
                    remotePolicy,
                    companyName,
                    alwaysBeenRemote,
                    policyDuration
                  )}
                </Typography>
              )
            }

          </Grid>
          {this.renderLabel("Since", str)}
          {this.remotePolicy === "temp-remote" ?
          this.renderLabel("Until", policyDuration && policyDuration === "indefinite" ? "Indefinite" : dateFormat(remoteUntil, formatStr))
          :
          <div></div>
          }
          {this.renderLabel("Policy", this.generatePolicy(remotePolicy), 12)}
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(RemoteStatus);
